import { gql } from '@apollo/client';

export const CREATE_INVENTORY_REQUEST = gql`
  mutation CreateInventoryRequest(
    $seller_id: String!,
    $move_type: String!,
    $stock_type: String!,
    $date: String!,
    $items: [InventoryItemInput!]!
  ) {
    createInventoryRequest(
      seller_id: $seller_id,
      move_type: $move_type,
      stock_type: $stock_type,
      date: $date,
      items: $items
    ) {
      status
      message
      inventory_requests {
        inv_id
        date
        status
      }
    }
  }
`;
